export enum allRoutes {
  default = "/",
  changePassword = "/passwort-aendern",
  forgotPassword = "/passwort-vergessen",
}
